/* eslint-disable */
import React, { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { GoogleGenerativeAI } from "@google/generative-ai";
import EventIcon from "@material-ui/icons/Event";

import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Box,
	Grid,
	TextField,
	Typography,
	Checkbox,
	FormGroup,
	FormControlLabel,
	Paper,
	IconButton,
	LinearProgress,
	StepLabel,
	Stepper,
	Step,
	StepIconProps,
	FormHelperText,
	Modal,
	Table,
	TableHead,
	TableRow,
	TableCell,
	ListItemText
} from "@mui/material";
import { Add, Check, Delete } from "@material-ui/icons";
import * as XLSX from "xlsx";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../../../../utils/api";
import { VEBConfig } from "../../../../../../constants/vebConfig";
import { Condition, FormField, MetaField, VEB_Plan } from "../../../../../../@types/plan.types";
import { CheckboxProps, MenuItem, TableBody } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { green } from "@material-ui/core/colors";
import createPalette from "@material-ui/core/styles/createPalette";
import { getPrompt } from "./dynamicVEBPrompt/getPrompt";
import { jsonToExcel } from "./SchemaToExcel";
import { flattenFormData } from "../../../../../../constants/VEBcommon/common";
import { Validation } from "../../../../../../@types/validation.types";
import { FIELD_NAMES, VALIDATION_MESSAGES, VALIDATION_STATUS } from "../../../../../../constants/createVebPlan";
import { getJsonFromBackend } from "../../../../../../utils/api/plan/gemini";
import { IoCloseCircleOutline } from "react-icons/io5";
import { getActiveVEBPlans } from "../../../../../../utils/api/plan/plan";

interface UpdateVEBPlanProps {
	initialData?: Record<string, any>;
	createdPlan?: any;
	onClose: () => void;
}
type PlanOrderItem = {
	plancode: string;
	planOrder: number;
	planName: string;
	planID: any;
};

const GreenStepIcon = (props: StepIconProps) => {
	const { completed, active, icon } = props;

	const circleStyle: React.CSSProperties = {
		width: 30,
		height: 30,
		borderRadius: "50%",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		fontSize: 18,
		fontWeight: 600,
		color: "white",
		background: completed
			? "linear-gradient(135deg, #4caf50, #2e7d32)"
			: active
			? "linear-gradient(135deg, #81c784, #4caf50)"
			: "#bdbdbd",
		border: "2px solid rgba(0,0,0,0.1)",
		boxShadow: active ? "0 0 12px rgba(76, 175, 80, 0.6)" : "0 2px 6px rgba(0,0,0,0.15)",
		transition: "all 0.3s ease, transform 0.2s ease",
		transform: active ? "scale(1.1)" : "scale(1)"
	};

	return <div style={circleStyle}>{completed ? <Check style={{ fontSize: 24 }} /> : icon}</div>;
};

const steps = [
	"Plan Details",
	"Coverage Options",
	"Benefit Structure",
	"Eligibility Criteria",
	"Add Riders",
	"Upload Excel"
];
const GreenCheckbox = withStyles({
	root: {
		color: green[400],
		"&$checked": {
			color: green[600]
		}
	},
	checked: {}
	// eslint-disable-next-line
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

const UpdateVEBPlan: React.FC<UpdateVEBPlanProps> = ({ createdPlan, onClose }) => {
	const navigate = useNavigate();
	const location = useLocation();
	// let validationCode: any;

	const [step, setStep] = useState(1);
	const [activePlans, setActivePlans] = useState<VEB_Plan[]>([]);

	const [planOrderList, setPlanOrderList] = useState<PlanOrderItem[]>([]);
	const [updatedPlan, setUpdatedPlan] = useState<VEB_Plan>();

	const [file, setFile] = useState<File | null>(null);
	const [jsonOutput, setJsonOutput] = useState<any>(null);
	const [Document, setDocument] = useState<File | null>();
	const [selectedFile, setSelectedFile] = useState<File | null>(null);
	const [showModal, setShowModal] = useState(false);
	const [targetOrder, setTargetOrder] = useState<number | null>(null);
	const [validationCode, setValidationCode] = useState<number | null>(null);
	const [activePlansNames, setActivePlansName] = useState<string[]>([]);
	const [activeRiderPlansNames, setActiveRiderPlansName] = useState<string[]>([]);
	const [loading, setLoading] = useState(false);
	const [validation, setValidation] = useState<Validation>({
		plan: {},
		status: VALIDATION_STATUS.valid
	});
	const prefilldata = flattenFormData({
		plan_name: createdPlan?.plan_name,
		carrier_name: createdPlan?.carrier_name,
		plan_code: createdPlan?.plan_code,
		plan_year: createdPlan?.plan_year,
		status: createdPlan?.status,
		employee_class: createdPlan?.employee_class,
		plan_order: createdPlan?.plan_order,
		start_date: createdPlan?.start_date || "",
		end_date: createdPlan?.end_date || "",
		auto_approve: createdPlan?.auto_approve || false,
		Beneficiaries: createdPlan?.beneficiaries_required,
		document: null,
		coverage_for: createdPlan?.coverage_for?.options || [],
		coverage_volume_present: createdPlan?.coverage_volume?.is_present || false,
		coverage_volume: createdPlan?.coverage_volume?.options || [],
		pay_frequency: createdPlan?.pay_frequency?.options || [],
		is_premium_depends_on_smoke: createdPlan?.is_premium_depends_on_smoke || false,
		is_benefit: createdPlan?.benefit_amount?.is_present || false,
		benefit_amount: createdPlan?.benefit_amount?.is_present
			? {
					is_present: true,
					enable_specific_benefit: !!createdPlan?.benefit_amount?.min_benefit ? true : false,
					min_benefit: createdPlan?.benefit_amount?.min_benefit ?? "",
					each_benefit_multiply_by: createdPlan?.benefit_amount?.each_benefit_multiply_by ?? "",
					max_benefit: createdPlan?.benefit_amount?.max_benefit ?? "",
					use_predefine_benefit:
						createdPlan?.benefit_amount?.min_benefit && createdPlan?.benefit_amount?.is_present
							? false
							: true,
					benefit_band_ranges: createdPlan?.benefit_amount?.options || []
			  }
			: {
					is_present: false,
					enable_specific_benefit: false,
					min_benefit: "",
					each_benefit_multiply_by: "",
					max_benefit: "",
					use_predefine_benefit: false,
					benefit_band_ranges: []
			  },
		is_this_plan_has_age_criteria: createdPlan?.age_criteria?.is_present || false,
		age_criteria: createdPlan?.age_criteria?.is_present
			? {
					use_age_bands: createdPlan?.age_criteria?.use_age_bands || false,
					age_band_ranges: createdPlan?.age_criteria?.age_band_ranges || [],

					enable_specific_ages: createdPlan?.age_criteria?.use_specific_ages || false,
					min_age: createdPlan?.age_criteria?.min_age || "",
					max_age: createdPlan?.age_criteria?.max_age || ""
			  }
			: {
					use_age_bands: false,
					age_band_ranges: [],
					enable_specific_ages: false,
					min_age: "",
					max_age: ""
			  },
		employee_eligibility: {
			min_age: createdPlan?.employee_eligibility?.employee?.min_age || "",
			max_age: createdPlan?.employee_eligibility?.employee?.max_age || ""
		},

		isdependent_eligibility: createdPlan?.dependent_eligibility?.is_present,
		dependent_eligibility: createdPlan?.dependent_eligibility?.is_present
			? {
					spouse: {
						min_age: createdPlan?.dependent_eligibility?.spouse?.min_age || "",
						max_age: createdPlan?.dependent_eligibility?.spouse?.max_age || "",
						can_spouse_has_max_benefit_amount_than_employee:
							createdPlan?.dependent_eligibility?.spouse
								?.can_spouse_has_max_benefit_amount_than_employee || false
					},
					children: {
						min_age: createdPlan?.dependent_eligibility?.children?.min_age || "",
						max_age: createdPlan?.dependent_eligibility?.children?.max_age || "",
						can_children_has_max_benefit_amount_than_employee:
							createdPlan?.dependent_eligibility?.children
								?.can_children_has_max_benefit_amount_than_employee || false
					},
					do_you_want_to_make_children_disabled:
						createdPlan?.dependent_eligibility?.children
							?.can_children_has_max_benefit_amount_than_employee || false,
					disabled: {
						min_age: createdPlan?.dependent_eligibility?.children?.disabled?.min_age || "",
						max_age: createdPlan?.dependent_eligibility?.children?.disabled?.max_age || "",
						children_can_exceed_employee_benefit:
							createdPlan?.dependent_eligibility?.children?.disabled
								?.children_can_exceed_employee_benefit || false
					},
					eligible_relationship: createdPlan?.dependent_eligibility?.eligible_relationship || [],
					in_eligible_relationship: createdPlan?.dependent_eligibility?.in_eligible_relationship || []
			  }
			: {
					spouse: { min_age: "", max_age: "", can_spouse_has_max_benefit_amount_than_employee: false },
					children: { min_age: "", max_age: "", can_children_has_max_benefit_amount_than_employee: false },
					do_you_want_to_make_children_disabled: false,
					disabled: { min_age: "", max_age: "", children_can_exceed_employee_benefit: false },
					eligible_relationship: [],
					ineligible_relationship: []
			  },

		is_this_plan_has_riders: createdPlan?.rider?.is_present || false,
		rider: {
			name: createdPlan?.rider?.name || "",
			is_rider_only_for_employee: createdPlan?.rider?.is_rider_only_for_employee || false,
			is_required: createdPlan?.rider?.is_required || false,
			is_rider_has_same_base_plan_coverage_for:
				createdPlan?.rider?.is_rider_has_same_base_plan_coverage_for || false,

			coverage_for: createdPlan?.rider?.coverage_for?.options || [],
			coverage_volume_present: createdPlan?.rider?.coverage_volume?.is_present || false,
			coverage_volume: createdPlan?.rider?.coverage_volume?.options || [],

			pay_frequency: createdPlan?.rider?.pay_frequency?.options || [],
			is_premium_depends_on_smoke: createdPlan?.rider?.is_premium_depends_on_smoke || false,
			is_benefit: createdPlan?.rider?.benefit_amount.is_present,
			// benefit_amount: createdPlan?.rider?.benefit_amount,
			benefit_amount: createdPlan?.rider?.benefit_amount?.is_present
				? {
						is_present: true,
						enable_specific_benefit: !!createdPlan?.rider?.benefit_amount?.min_benefit ? true : false,
						min_benefit: createdPlan?.rider?.benefit_amount?.min_benefit ?? "",
						each_benefit_multiply_by: createdPlan?.rider?.benefit_amount?.each_benefit_multiply_by ?? "",
						max_benefit: createdPlan?.rider?.benefit_amount?.max_benefit ?? "",
						use_predefine_benefit:
							createdPlan?.rider?.benefit_amount?.min_benefit &&
							createdPlan?.rider?.benefit_amount?.is_present
								? false
								: true,
						benefit_band_ranges: createdPlan?.rider?.benefit_amount?.options || []
				  }
				: {
						is_present: false,
						enable_specific_benefit: false,
						min_benefit: "",
						each_benefit_multiply_by: "",
						max_benefit: "",
						use_predefine_benefit: false,
						benefit_band_ranges: []
				  },
			is_this_plan_has_age_criteria: createdPlan?.rider?.age_criteria?.is_present,
			// age_criteria: createdPlan?.rider?.age_criteria

			age_criteria: createdPlan?.age_criteria?.is_present
				? {
						use_age_bands: createdPlan?.rider?.age_criteria?.use_age_bands || false,
						age_band_ranges: createdPlan?.rider?.age_criteria?.age_band_ranges || [],

						enable_specific_ages: createdPlan?.rider?.age_criteria?.use_specific_ages || false,
						min_age: createdPlan?.rider?.age_criteria?.min_age || "",
						max_age: createdPlan?.rider?.age_criteria?.max_age || ""
				  }
				: {
						use_age_bands: false,
						age_band_ranges: [],
						enable_specific_ages: false,
						min_age: "",
						max_age: ""
				  }
		},
		depends_on_standard_plan: Boolean(createdPlan?.standard_plan_dependency?.length),
		standard_plan_dependency: createdPlan?.standard_plan_dependency || [],

		depends_on_rider_plan: Boolean(createdPlan?.rider_plan_dependency?.length),
		rider_plan_dependency: createdPlan?.rider_plan_dependency || []
	});

	const [formData, setFormData] = useState<Record<string, any>>(() => ({ ...prefilldata }));
	// console.log("1478547", formData);
	console.log("prefilldata", prefilldata);

	// const genAI = new GoogleGenerativeAI("AIzaSyA4Gk0TRz_yfIm35fNbg_lOjmB7gTYWEGY");

	const handleChange = (name: string, value: any) => {
		setFormData((prev) => ({ ...prev, [name]: value }));
		// console.log("setFormData", name, value);
	};

	const _validation = useRef<Validation>();
	const getallplans = useCallback(async () => {
		try {
			if (!createdPlan.group_number) return;

			const { currentPlans, futurePlans } = await getActiveVEBPlans(createdPlan.group_number as number);

			//console.log("hi all the plans", currentPlans, futurePlans);
			setActivePlans(currentPlans);
			//console.log("all plans ", activePlans);
		} catch (error) {
			console.error(error);
		}
	}, [createdPlan.group_number]);

	const handleMoveToPosition = useCallback(
		(targetOrder: number) => {
			if (!targetOrder || planOrderList.length === 0) return;

			const sorted = [...planOrderList].sort((a, b) => a.planOrder - b.planOrder);

			let firstConflictIndex = -1;

			//  Shift & capture FIRST conflict
			for (let i = 0; i < sorted.length; i++) {
				if (sorted[i].planOrder >= targetOrder) {
					if (firstConflictIndex === -1) {
						firstConflictIndex = i; // FIRST occurrence
					}

					sorted[i] = {
						...sorted[i],
						planOrder: sorted[i].planOrder + 1
					};
				}
			}

			// Fix gaps / duplicates AFTER first occurrence
			if (firstConflictIndex > 0) {
				for (let i = firstConflictIndex + 1; i < sorted.length; i++) {
					if (sorted[i].planOrder - sorted[i - 1].planOrder !== 1) {
						sorted[i] = {
							...sorted[i],
							planOrder: sorted[i - 1].planOrder + 1
						};
					}
				}
			}

			setPlanOrderList(sorted);
			setShowModal(false);
		},
		[planOrderList]
	);

	const updateAllplanOrder = useCallback(async () => {
		//console.log("Updating plans", planOrderList);

		if (!planOrderList.length) return;

		const results = await Promise.allSettled(
			planOrderList.map((plan) => {
				if (!plan.planID || plan.planOrder == null) {
					return Promise.resolve(null);
				}

				return trackPromise(
					api.plan.updateVEBPlanOrder(plan.planID, {
						plan_order: Number(plan.planOrder)
					})
				);
			})
		);

		//console.log("Update result", results);
	}, [planOrderList]);

	const handleValidation = useCallback(async () => {
		if (!formData) return false;

		const {
			plan_name = "",
			plan_code = "",
			carrier_name = "",
			status = [],
			is_end_date_required = false,
			employee_class = [],
			start_date,
			plan_year = "",
			plan_order,
			end_date
		} = formData;

		_validation.current = { plan: {}, status: VALIDATION_STATUS.invalid };
		let flag = true;
		let alertMessage = false;

		// --- String fields ---
		// console.log("formdata", formData.start_date);

		if (!plan_name || (typeof plan_name === "string" && plan_name.trim().length === 0)) {
			_validation.current.plan[FIELD_NAMES.plan_name] = VALIDATION_MESSAGES.plan_name_required;
			flag = false;
			alertMessage = true;
		}
		if (!plan_code || (typeof plan_code === "string" && plan_code.trim().length === 0)) {
			_validation.current.plan[FIELD_NAMES.plan_code] = VALIDATION_MESSAGES.plan_code_required;
			flag = false;
			alertMessage = true;
		}
		if (!carrier_name || (typeof carrier_name === "string" && carrier_name.trim().length === 0)) {
			_validation.current.plan[FIELD_NAMES.carrier_name] = VALIDATION_MESSAGES.carrier_name_required;
			flag = false;
			alertMessage = true;
		}
		if (!plan_year || (typeof plan_year === "string" && plan_year.trim().length === 0)) {
			_validation.current.plan[FIELD_NAMES.plan_year] = VALIDATION_MESSAGES.plan_year_required;
			flag = false;
			alertMessage = true;
		}
		if (!plan_order && plan_order !== 0) {
			_validation.current.plan[FIELD_NAMES.planOrder] = "Plan order is required.";
			flag = false;
			alertMessage = true;
		} else {
			const currentPlanOrder = Number(plan_order);
			//console.log("currentPlanOrder", currentPlanOrder);

			if (Number.isNaN(currentPlanOrder)) {
				_validation.current.plan[FIELD_NAMES.planOrder] = "Plan order must be a number.";
				flag = false;
				alertMessage = true;
			} else {
				const isDuplicatePlanOrder = planOrderList.some(
					(p) => p.planOrder === currentPlanOrder && p.plancode !== plan_code
				);
				//console.log("isDuplicatePlanOrder", isDuplicatePlanOrder);

				if (isDuplicatePlanOrder) {
					_validation.current.plan[FIELD_NAMES.planOrder] =
						"This plan order is already assigned to another plan.";
					flag = false;
					setShowModal(true);
					alertMessage = true;
				}
			}
		}

		// --- Date fields ---
		if (!start_date || start_date.toString().trim() === "" || isNaN(new Date(start_date).getTime())) {
			_validation.current.plan[FIELD_NAMES.start_date] = VALIDATION_MESSAGES.start_date_required;
			flag = false;
			alertMessage = true;
		}

		if (is_end_date_required && !end_date) {
			_validation.current.plan[FIELD_NAMES.end_date] = VALIDATION_MESSAGES.end_date_required;
			flag = false;
			alertMessage = true;
		}

		// Compare start and end dates only if both exist
		if (start_date && end_date) {
			const startTime = new Date(start_date).getTime();
			const endTime = new Date(end_date).getTime();

			if (startTime === endTime) {
				_validation.current.plan[FIELD_NAMES.end_date] = "Start Date and End Date cannot be the same.";
				flag = false;
				alertMessage = true;
			} else if (startTime > endTime) {
				_validation.current.plan[FIELD_NAMES.end_date] = VALIDATION_MESSAGES.end_date_invalid;
				flag = false;
				alertMessage = true;
			}
		}

		// --- Array fields ---
		if ((!status && typeof status === "string") || (Array.isArray(status) && status.length === 0)) {
			_validation.current.plan[FIELD_NAMES.status] = VALIDATION_MESSAGES.status_required;
			flag = false;
			alertMessage = true;
		}

		// For employee_class
		if (
			(!employee_class && typeof employee_class === "string") ||
			(Array.isArray(employee_class) && employee_class.length === 0)
		) {
			_validation.current.plan[FIELD_NAMES.employee_class] = VALIDATION_MESSAGES.employee_class_required;
			flag = false;
			alertMessage = true;
		}

		// --- Set validation state ---
		_validation.current.status = flag ? VALIDATION_STATUS.valid : VALIDATION_STATUS.invalid;
		setValidation({ ..._validation.current });
		if (!flag && alertMessage) {
			alert("Please, fill all required Plan details!");
		}

		return flag;
	}, [formData, planOrderList, setShowModal]);

	const handleCancel = () => {
		// setShiftAndMoveToLastPlanOrder({ moveToLast: false, shift: false });
		setShowModal(false);
	};

	const handleFormValidation = (): boolean => {
		if (step === 2) {
			if (!formData.coverage_for?.length) {
				alert("Please fill in coverage");
				return false;
			}

			if (!formData.pay_frequency?.length) {
				alert("Please fill in payment frequency");
				return false;
			}

			if (formData.coverage_volume_present) {
				if (!formData.coverage_volume || formData.coverage_volume.length <= 0) {
					alert("Please fill in coverage volume.");
					return false;
				}
			}
		}

		//  Step 3: Rider Benefit Amount validation
		if (step === 3) {
			if (formData["is_benefit"]) {
				const specific = formData["benefit_amount.enable_specific_benefit"];
				const hasBands = formData["benefit_amount.use_predefine_benefit"];
				const min = Number(formData["benefit_amount.min_benefit"]);
				const max = Number(formData["benefit_amount.max_benefit"]);
				const specificList = formData["benefit_amount.specific_age_list"];
				const bands = formData["benefit_amount.benefit_band_ranges"];

				if (!hasBands && !specific) {
					alert("Select at least one option to proceed");
					return false;
				}
				if (hasBands) {
					if (
						!Array.isArray(bands) ||
						bands.length < 1 ||
						bands.some(
							(b) =>
								b == null || // catches undefined or null
								(typeof b === "string" && b.trim() === "") // catches blank strings
						)
					) {
						alert("Please fill in specific benefit ranges properly.");
						return false;
					}
				}
				if (specific) {
					if (!min && !max) {
						alert("Please fill in minimum and maximum benefit");
						return false;
					}
					if (min >= max) {
						alert("Minimum benefit must be less than maximum benefit.");
						return false;
					}
				}
			}
		}
		if (step === 4) {
			// --- Employee Eligibility Validation ---

			const minAge = Number(formData["employee_eligibility.min_age"]);
			const maxAge = Number(formData["employee_eligibility.max_age"]);
			// console.log("maxAge", minAge, maxAge);

			if (Number.isNaN(minAge) || Number.isNaN(maxAge)) {
				alert("Employee minimum and maximum age must be numbers.");
				return false;
			}

			if (minAge < 0 || maxAge < 0) {
				alert("Employee age cannot be negative.");
				return false;
			}

			if (minAge >= maxAge) {
				alert("Employee minimum age must be less than maximum age.");
				return false;
			}
		}

		//  Step 4: Age criteria (base plan and rider)
		if (step === 4) {
			// --- Base Plan ---
			if (formData["is_this_plan_has_age_criteria"]) {
				const hasBands = formData["age_criteria.use_age_bands"];
				const bands = formData["age_criteria.age_band_ranges"];
				const specific = formData["age_criteria.enable_specific_ages"];
				const specificList = formData["age_criteria.specific_age_list"];
				const min = Number(formData["age_criteria.min_age"]);
				const max = Number(formData["age_criteria.max_age"]);
				if (!hasBands && !specific) {
					alert("Select at least one option to proceed");
					return false;
				}

				if (hasBands) {
					// basic checks for array and length
					if (!Array.isArray(bands) || bands.length < 1) {
						alert("Please provide at least one age band (e.g. 10-20).");
						return false;
					}

					// parse and validate each band into numeric ranges
					type Range = { min: number; max: number; raw: string };
					const parsed: Range[] = [];

					const validPattern = /^\s*\d+\s*-\s*\d+\s*$/;

					for (const b of bands) {
						if (b == null || (typeof b === "string" && b.trim() === "")) {
							alert("Empty age band found. Please fill them in properly (e.g. 10-20).");
							return false;
						}

						if (typeof b !== "string" || !validPattern.test(b.trim())) {
							alert(`Invalid format for age band "${b}". Use the form "min-max", e.g. 10-20.`);
							return false;
						}

						const [min, max] = b.split("-").map((x) => Number(x.trim()));

						if (Number.isNaN(min) || Number.isNaN(max) || min < 0 || max < 0) {
							alert(`Non-numeric or negative values in age band "${b}". Use non-negative numbers.`);
							return false;
						}

						if (min >= max) {
							alert(`Invalid range "${b}". Minimum must be less than maximum (e.g. 10-20).`);
							return false;
						}

						parsed.push({ min, max, raw: b.trim() });
					}

					// sort ranges by min to check for overlaps/duplicates
					parsed.sort((a, b) => a.min - b.min);

					for (let i = 1; i < parsed.length; i++) {
						const prev = parsed[i - 1];
						const cur = parsed[i];

						// overlap or touching ranges: treat cur.min <= prev.max as invalid (change to < if touching is allowed)
						if (cur.min <= prev.max) {
							alert(
								`Overlapping or duplicate ranges detected: "${prev.raw}" and "${cur.raw}". Please provide non-overlapping ranges.`
							);
							return false;
						}
					}

					// if we reach here, validation passed and function continues (no explicit `return true`)
				}

				if (specific) {
					if (!min && !max) {
						alert("Looks like you missed base plan minimum and maximum  . Please fill them in.");
						return false;
					}
					if (min >= max) {
						alert(
							"Looks like you missed base plan minimum and maximum are same or min is bigger than max  . Please fill them in."
						);
						return false;
					}
				}
			}

			// --- Rider ---
		}

		//  Step 5: Dependent eligibility checks
		if (step === 4) {
			// --- MAIN DEPENDENT ELIGIBILITY ---
			if (formData.isdependent_eligibility) {
				const dependent = formData["isdependent_eligibility"];
				const spouseMin = Number(formData["dependent_eligibility.spouse.min_age"]);
				const spouseMax = Number(formData["dependent_eligibility.spouse.max_age"]);
				const disMin = Number(formData["dependent_eligibility.disabled.min_age"]);
				const disMax = Number(formData["dependent_eligibility.disabled.max_age"]);
				const eligible_relationship = Array.isArray(formData?.["dependent_eligibility.eligible_relationship"]);
				const in_eligible_relationship = Array.isArray(
					formData?.["dependent_eligibility.in_eligible_relationship"]
				);
				// Validate children ages
				const childMin = Number(formData["dependent_eligibility.children.min_age"]);
				const childMax = Number(formData["dependent_eligibility.children.max_age"]);

				//  Check eligible relationship
				if (!spouseMin && !spouseMax) {
					if (spouseMax < spouseMin) {
						alert("Spouse maximum age must be greater than   minimum age");
						return false;
					}
					alert("Please select at least one eligible relationship for dependents.");
					return false;
				}

				if (!childMin && !childMax) {
					if (childMax < childMin) {
						alert("Spouse maximum age must be greater than minimum age.");
						return false;
					}
					alert("Please select at least one eligible relationship for dependents.");
					return false;
				}

				//  Validate disabled child ages

				if (disMax < disMin) {
					alert("Disabled children maximum age must be greater than or equal to minimum age.");
					return false;
				}
				if (!eligible_relationship) {
					alert("Please select at least one eligible relationship for dependents.");
					return false;
				}
				// if (!in_eligible_relationship) {
				// 	alert("Please select at least one ineligible relationship for dependents.");
				// 	return false;
				// }
			}

			// --- RIDER DEPENDENT ELIGIBILITY ---
		}

		if (step === 5) {
			if (formData.is_this_plan_has_riders) {
				const rider = formData.rider;
				let coverageFor: any[] = [];
				if (formData["rider.is_rider_only_for_employee"]) {
					coverageFor = ["Employee Only"];
				} else if (formData["rider.is_rider_has_same_base_plan_coverage_for"]) {
					coverageFor = formData.coverage_for || [];
				} else {
					coverageFor = formData["rider.coverage_for"] || [];
				}
				// normalize to ensure array
				const normalizedCoverageFor = Array.isArray(coverageFor)
					? coverageFor
					: coverageFor
					? [coverageFor]
					: [];

				if (!formData["rider.name"]) {
					alert("Please enster the rider name.");
					return false;
				}

				if (
					normalizedCoverageFor.length === 0 ||
					normalizedCoverageFor.some((item) => item == null || String(item).trim() === "")
				) {
					alert("Looks like you missed coverage. Please fill it in.");
					return false;
				}

				//  Check pay_frequency array
				const payFrequency = formData["rider.pay_frequency"];

				// ensure it’s an array — if it’s a string, wrap it in an array
				const normalizedPayFrequency = Array.isArray(payFrequency)
					? payFrequency
					: payFrequency
					? [payFrequency]
					: [];

				if (
					normalizedPayFrequency.length === 0 ||
					normalizedPayFrequency.some((item) => item == null || String(item).trim() === "")
				) {
					alert("Looks like you missed payment frequency. Please fill it in.");
					return false;
				}

				//  Check coverage_volume if present
				if (formData["rider.coverage_volume_present"]) {
					const coverageVolume = formData["rider.coverage_volume"];
					if (
						!Array.isArray(coverageVolume) ||
						coverageVolume.length === 0 ||
						coverageVolume.some((item: any) => item == null || item === "")
					) {
						alert("Looks like you missed coverage volume. Please fill it in.");
						return false;
					}
				}

				//  if everything passes, execution continues naturally

				if (formData["rider.is_benefit"]) {
					const specific = formData["rider.benefit_amount.enable_specific_benefit"];
					const hasBands = formData["rider.benefit_amount.use_predefine_benefit"];
					const min = Number(formData["rider.benefit_amount.min_benefit"]);
					const max = Number(formData["rider.benefit_amount.max_benefit"]);

					const bands = formData["rider.benefit_amount.benefit_band_ranges"];

					if (!hasBands && !specific) {
						alert("Looks like you missed base plan  band ranges. Please fill them in.");
						return false;
					}
					if (hasBands) {
						if (
							!Array.isArray(bands) ||
							bands.length < 1 ||
							bands.some(
								(b) =>
									b == null || // catches undefined or null
									(typeof b === "string" && b.trim() === "") // catches blank strings
							)
						) {
							alert("Looks like you missed base plan specific ranges. Please fill them in properly.");
							return false;
						}
					}
					if (specific) {
						if (!min && !max) {
							alert("Looks like you missed base plan minimum and maximum  . Please fill them in.");
							return false;
						}
						if (min >= max) {
							alert(
								"Looks like you missed base plan minimum and maximum are same or min is bigger than max  . Please fill them in."
							);
							return false;
						}
					}
				}

				if (formData["rider.is_this_plan_has_age_criteria"]) {
					const hasBands = formData["rider.age_criteria.use_age_bands"];
					const bands = formData["rider.age_criteria.age_band_ranges"];
					const specific = formData["rider.age_criteria.enable_specific_ages"];
					const specificList = formData["rider.age_criteria.specific_age_list"];
					const min = Number(formData["rider.age_criteria.min_age"]);
					const max = Number(formData["rider.age_criteria.max_age"]);
					if (!hasBands && !specific) {
						alert("Looks like you missed base plan age band ranges. Please fill them in.");
						return false;
					}

					if (hasBands) {
						if (
							!Array.isArray(bands) ||
							bands.length < 1 ||
							bands.some((b) => {
								// missing or empty
								if (b == null || (typeof b === "string" && b.trim() === "")) return true;

								//  must match "10-20" pattern
								const validPattern = /^\s*\d+\s*-\s*\d+\s*$/;
								if (typeof b !== "string" || !validPattern.test(b.trim())) return true;

								//  extract numbers
								const [min, max] = b.split("-").map((x) => Number(x.trim()));

								if (Number.isNaN(min) || Number.isNaN(max) || min < 0 || max < 0 || min >= max)
									return true;

								return false;
							})
						) {
							alert(
								"Looks like you missed base plan specific ranges. Please fill them in properly (e.g. 10-20, 21-30)."
							);
							return false; //  stop execution only when invalid
						}

						//  if everything is valid, execution will continue naturally
					}

					if (specific) {
						if (!min && !max) {
							alert("Looks like you missed base plan minimum and maximum  . Please fill them in.");
							return false;
						}
						if (min >= max) {
							alert(
								"Looks like you missed base plan minimum and maximum are same or min is bigger than max  . Please fill them in."
							);
							return false;
						}
					}
				}

				if (formData["rider.is_rider_dependent_eligibility"]) {
					const dependent = formData["rider.is_rider_dependent_eligibility"];
					const spouseMin = Number(formData["rider.dependent_eligibility.spouse.min_age"]);
					const spouseMax = Number(formData["rider.dependent_eligibility.spouse.max_age"]);
					const disMin = Number(formData["rider.dependent_eligibility.disabled.min_age"]);
					const disMax = Number(formData["rider.dependent_eligibility.disabled.max_age"]);
					const eligible_relationship = Array.isArray(
						formData?.["rider.dependent_eligibility.eligible_relationship"]
					);
					const in_eligible_relationship = Array.isArray(
						formData?.["rider.dependent_eligibility.in_eligible_relationship"]
					);
					//  Validate children ages
					const childMin = Number(formData["rider.dependent_eligibility.children.min_age"]);
					const childMax = Number(formData["rider.dependent_eligibility.children.max_age"]);

					//  Check eligible relationship
					if (!spouseMin && !spouseMax) {
						if (spouseMax < spouseMin) {
							alert("Spouse maximum age must be greater than or equal to minimum age.");
							return false;
						}
						alert("Please select at least one eligible relationship for dependents.");
						return false;
					}

					if (!childMin && !childMax) {
						if (childMax < childMin) {
							alert("Spouse maximum age must be greater than or equal to minimum age.");
							return false;
						}
						alert("Please select at least one eligible relationship for dependents.");
						return false;
					}

					//  Validate disabled child ages

					if (disMax < disMin) {
						alert("Disabled children maximum age must be greater than or equal to minimum age.");
						return false;
					}
					if (!eligible_relationship) {
						alert("Please select at least one eligible relationship for dependents.");
						return false;
					}
					if (!in_eligible_relationship) {
						alert("Please select at least one ineligible relationship for dependents.");
						return false;
					}
				}
			}
		}

		return true;
	};
	//console.log("this is the formData", formData);
	const createValidationCode = (): string => {
		return Math.floor(100000 + Math.random() * 900000).toString();
	};
	const renderField = useCallback(
		(field: FormField | MetaField, parentKey?: string) => {
			const fieldKey = parentKey ? `${parentKey}.${field.name}` : field.name;
			const getFieldValue = (key: string) =>
				key in formData ? formData[key] : prefilldata[key] || (field.type === "array" ? [""] : "");

			// if (field.condition) {
			// 	const currentValue = getFieldValue(field.condition.field);
			// 	const conditionValues = Array.isArray(field.condition.value)
			// 		? field.condition.value
			// 		: [field.condition.value];
			// 	if (!conditionValues.some((val) => val == currentValue)) return null; // loose comparison
			// }
			if (field.condition) {
				const conditions = Array.isArray(field.condition) ? field.condition : [field.condition];

				const evaluateCondition = (cond: Condition): boolean => {
					const currentValue = formData[cond.field];
					let match = false;

					if (cond.includes !== undefined) {
						if (Array.isArray(currentValue)) {
							match = currentValue.includes(cond.includes);
						}
					} else if (cond.value !== undefined) {
						const conditionValues = Array.isArray(cond.value) ? cond.value : [cond.value];
						match = conditionValues.includes(currentValue);
					}

					return cond.not ? !match : match; // ← not is applied per-clause
				};
				const operator = field.conditionOperator === "OR" ? "OR" : "AND";

				const shouldRender =
					operator === "OR" ? conditions.some(evaluateCondition) : conditions.every(evaluateCondition);

				if (!shouldRender) return null;
			}
			const isDependentChild = parentKey?.startsWith("dependent_eligibility");

			const hasAgecriteriya = parentKey?.startsWith("age_criteria");
			const hasRider = parentKey?.startsWith("rider");
			// const hasRider = parentKey === "rider";

			const isReadOnly = ["plan_name", "plan_code"].some((suffix) => fieldKey.endsWith(suffix));
			const benefit = parentKey?.startsWith("benefit_amount");

			const fieldContainerStyles = {
				display: "flex",
				flexWrap: "wrap",
				mb: 2,
				p: { xs: 1, sm: 2 }, // responsive padding
				borderRadius: 2,
				backgroundColor: hasAgecriteriya || isDependentChild || hasRider || benefit ? "#F0EBEB" : "#ffffff"
			};

			const responsiveInputStyle = {
				width: "100%",
				maxWidth: 340,
				height: 60,
				"& .MuiInputBase-input": {
					padding: "14px 16px"
				},
				borderRadius: 1
			};

			// META FIELD
			if (field.type === "meta" && field.fields) {
				return (
					<Box
						key={fieldKey}
						sx={{
							...fieldContainerStyles,
							// border: "1px solid #e0e0e0",
							// boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
							width: { xs: "100%", md: "1150px" },
							overflow: "hidden",
							backgroundColor: "#F0EBEB"
						}}
					>
						{field.label && (
							<Typography fontWeight={600} sx={{ width: { xs: "100%", md: "800px" }, height: 50, p: 1 }}>
								{field.label}
							</Typography>
						)}
						{field.fields.map((subField: any) => renderField(subField, fieldKey))}
					</Box>
				);
			}
			if (field.type === "dropdown") {
				const selectedValues: string[] = formData[fieldKey] || [];
				const options: string[] =
					field.optionsKey === "activePlans"
						? activePlansNames
						: field.optionsKey === "activeRiderPlans"
						? activeRiderPlansNames
						: [];

				return (
					<Grid container spacing={2} key={fieldKey} sx={{ ...fieldContainerStyles, marginLeft: "1px" }}>
						<Grid item xs={12} sm={5} md={4}>
							<div className="pf-label-text">{field.label}</div>
						</Grid>

						<Grid item xs={12} sm={7} md={8}>
							<TextField
								select
								size="small"
								fullWidth
								value={selectedValues}
								onChange={(e) => handleChange(fieldKey, e.target.value)}
								SelectProps={{
									multiple: true,
									MenuProps: {
										PaperProps: {
											style: {
												maxHeight: 200
											}
										}
									},
									renderValue: (selected) =>
										(selected as string[]).length
											? (selected as string[]).join(", ")
											: "Select options"
								}}
								sx={{
									// ...smallInputStyle,
									"& .MuiInputBase-root": {
										// height: 36 // 🔥 small input height
									}
								}}
							>
								{options.map((option) => (
									<MenuItem key={option} value={option}>
										<Checkbox checked={selectedValues.includes(option)} size="small" />
										<ListItemText primary={option} />
									</MenuItem>
								))}
							</TextField>
						</Grid>
					</Grid>
				);
			}

			// ARRAY FIELD
			if (field.type === "array") {
				const arrayValues: string[] = getFieldValue(fieldKey);
				const handleArrayChange = (index: number, value: string) => {
					const updated = [...arrayValues];
					updated[index] = value;
					handleChange(
						fieldKey,
						updated.filter((v) => v.trim() !== "")
					);
				};
				const addItem = () => handleChange(fieldKey, [...arrayValues, ""]);
				const removeItem = (index: number) =>
					handleChange(
						fieldKey,
						arrayValues.filter((_, i) => i !== index)
					);
				const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
					if (e.key === "Enter") {
						e.preventDefault();
						addItem();
					}
				};

				return (
					<Grid container spacing={2} key={fieldKey} sx={{ ...fieldContainerStyles, border: "none" }}>
						<Grid item xs={12} sm={5} md={4}>
							<div className="pf-label-text">{field.label}</div>
						</Grid>
						<Grid item xs={12} sm={7} md={8}>
							{arrayValues.map((val, index) => (
								<Grid
									container
									spacing={1}
									alignItems="center"
									key={index}
									sx={{ mb: 1, flexWrap: { xs: "wrap", sm: "nowrap" } }}
								>
									<Grid item xs={12} sm={8} md={9}>
										<TextField
											fullWidth
											size="small"
											variant="outlined"
											value={val}
											onChange={(e) => handleArrayChange(index, e.target.value)}
											onKeyDown={handleKeyDown}
											sx={{
												width: { xs: "100%", sm: "160px", md: "200px" },
												"& .MuiInputBase-input": { padding: "6px 10px" }
											}}
										/>
									</Grid>
									<Grid item xs={12} sm={4} md={3}>
										<IconButton
											color="error"
											onClick={() => removeItem(index)}
											sx={{ mt: { xs: 1, sm: 0 }, width: "100%", height: 32 }}
										>
											<Delete />
										</IconButton>
									</Grid>
								</Grid>
							))}
							<Box sx={{ mt: 1 }}>
								<Button
									variant="contained"
									startIcon={<Add />}
									onClick={addItem}
									sx={{ width: { xs: "100%", sm: "auto" }, height: 30, minWidth: 80 }}
								>
									Add
								</Button>
							</Box>
						</Grid>
					</Grid>
				);
			}

			// MULTISELECT FIELD
			if (field.type === "multiselect") {
				let selectedValues: string[] = formData[fieldKey] || [];
				let selectedValues2: string[] = [];
				//console.log("123", formData["dependent_eligibility.eligible_relationship"]);
				if (fieldKey === "rider.coverage_for" && formData["rider.is_rider_only_for_employee"]) {
					(selectedValues2 = ["Employee Only"]), (selectedValues = selectedValues2);
				} else if (
					fieldKey === "rider.coverage_for" &&
					formData["rider.is_rider_has_same_base_plan_coverage_for"]
				) {
					selectedValues2 = Array.isArray(formData.coverage_for)
						? formData.coverage_for
						: formData.coverage_for?.options || [];
					selectedValues = selectedValues2;
				}
				const toggleOption = (option: string) => {
					let updatedValues: string[];

					if (selectedValues.includes(option)) {
						// remove option
						updatedValues = selectedValues.filter((v) => v !== option);
					} else {
						// add option
						if (
							fieldKey === "rider.coverage_for" &&
							formData["rider.is_rider_has_same_base_plan_coverage_for"]
						) {
							updatedValues = Array.from(new Set([...selectedValues2, option]));
						} else {
							updatedValues = [...selectedValues, option];
						}
					}

					handleChange(fieldKey, updatedValues);
				};

				return (
					<Grid container key={fieldKey} spacing={2} sx={{ ...fieldContainerStyles, ml: 0 }}>
						<Grid item xs={12} md={3}>
							<div className="pf-label-text">{field.label}</div>
						</Grid>
						<Grid item xs={12} md={9}>
							<FormGroup>
								{field.options?.map((option) => (
									<FormControlLabel
										key={option}
										control={
											<GreenCheckbox
												checked={selectedValues.includes(option)}
												onChange={() => toggleOption(option)}
											/>
										}
										label={option}
									/>
								))}
							</FormGroup>
						</Grid>
					</Grid>
				);
			}

			// CHECKBOX FIELD
			if (field.type === "checkbox") {
				return (
					<Grid container key={fieldKey} spacing={2} sx={{ ...fieldContainerStyles, ml: 0 }}>
						<Grid item xs={12} md={3}>
							<div className="pf-label-text">{field.label}</div>
						</Grid>
						<Grid item xs={12} md={9}>
							<FormGroup>
								<FormControlLabel
									control={
										<GreenCheckbox
											checked={Boolean(getFieldValue(fieldKey))}
											onChange={(e) => handleChange(fieldKey, e.target.checked)}
										/>
									}
									label=""
								/>
							</FormGroup>
						</Grid>
					</Grid>
				);
			}

			// DATE FIELD
			if (field.type === "date") {
				const dateValue = getFieldValue(fieldKey) ? new Date(getFieldValue(fieldKey)) : null;
				return (
					<Grid container spacing={2} key={fieldKey} sx={{ ...fieldContainerStyles }}>
						<Grid item xs={12} md={3}>
							<div className="pf-label-text required">{field.label}</div>
						</Grid>
						<Grid item xs={12} md={9}>
							<MuiPickersUtilsProvider utils={DateFnsUtils}>
								<KeyboardDatePicker
									fullWidth
									inputVariant="outlined"
									label={field.label}
									format="MM/dd/yyyy"
									value={dateValue}
									onChange={(date) => {
										if (!date) return;
										const formattedDate = `${date.getFullYear()}-${
											date.getMonth() + 1
										}-${date.getDate()}`;
										handleChange(fieldKey, formattedDate);
									}}
									InputLabelProps={{ shrink: true }}
									keyboardIcon={<EventIcon style={{ color: "#4caf50" }} />}
									KeyboardButtonProps={{ "aria-label": "change date", style: { color: "#4caf50" } }}
									style={{ width: "100%", maxWidth: 340, height: 60, borderRadius: 8 }}
									InputProps={{ style: { height: 60, padding: "14px 16px" } }}
								/>
							</MuiPickersUtilsProvider>
						</Grid>
					</Grid>
				);
			}

			if (field.type === "file") {
				const currentFile = createdPlan?.document; // GridFS file object
				//console.log(createdPlan?.document);

				const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
					const file = e.target.files?.[0];
					if (!file) return;

					// Validate PDF
					if (file.type !== "application/pdf") {
						alert("Only PDF files are allowed");
						e.target.value = "";
						return;
					}

					setLoading(true);
					try {
						setDocument(file); // ← This updates your React state
						//console.log("Selected file:", file, "Existing file:", currentFile?.originalname);
					} finally {
						setLoading(false);
					}
				};

				return (
					<Grid container spacing={2} key={fieldKey} sx={{ ...fieldContainerStyles, ml: 0 }}>
						<Grid item xs={12} md={3}>
							<div className="pf-label-text">{field.label}</div>
						</Grid>

						<Grid item xs={12} md={9}>
							<Button variant="outlined" component="label" fullWidth sx={{ maxWidth: 340 }}>
								Upload PDF
								<input type="file" accept=".pdf,application/pdf" hidden onChange={handleFileChange} />
							</Button>

							{/* Show ONLY the filename */}
							{/* {(selectedFile || currentFile) && (
								<Typography variant="body2" sx={{ mt: 1 }}>
									{selectedFile?.name
										? selectedFile.name
										: // NEW uploaded file
										  currentFile?.originalname || "Existing file"}
								</Typography>
							)} */}
							<Typography variant="body2" sx={{ mt: 1 }}>
								{Document?.name ? Document.name : currentFile?.originalname || "no file"}
							</Typography>
						</Grid>
					</Grid>

					// <Grid container spacing={2} key={fieldKey}>
					// 	<Grid item xs={12}>
					// 		<input type="file" accept="application/pdf" onChange={handleFileChange} />

					// 		{/* Show existing GridFS file */}
					// 		{currentFile && !Document && <p>Current file: {currentFile.originalname}</p>}

					// 		{/* Show new selected file */}
					// 		{Document && <p>Selected file: {Document.name}</p>}
					// 	</Grid>
					// </Grid>
				);
			}

			if (field.type === "excelfile") {
				const isExcel = field.type === "excelfile";
				const currentFile = isExcel ? file : createdPlan.Document;
				const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
					if (!e.target.files || !e.target.files[0]) return;
					const selectedFile = e.target.files[0];
					const fileName = selectedFile.name.toLowerCase();
					const fileExtension = fileName.split(".").pop();
					setLoading(true);
					try {
						if (isExcel && !["xlsx", "xls", "csv"].includes(fileExtension || "")) {
							alert("Please upload only Excel files (.xlsx, .xls, .csv)");
							return;
						}
						if (isExcel) setFile(selectedFile);
						else setDocument(selectedFile);
						if (isExcel) await handleConvert(selectedFile);
					} catch (error) {
					} finally {
						setLoading(false);
					}
				};

				return (
					<Grid container spacing={2} key={fieldKey} sx={{ ...fieldContainerStyles, ml: 0 }}>
						<Grid item xs={12} md={3}>
							<div className="pf-label-text">{field.label}</div>
						</Grid>
						<Grid item xs={12} md={9}>
							<Button variant="outlined" component="label" fullWidth sx={{ maxWidth: 340 }}>
								{isExcel ? "Upload Excel File" : "Upload File"}
								<input
									type="file"
									hidden
									accept={isExcel ? ".xlsx,.xls,.csv" : undefined}
									onChange={handleFileChange}
								/>
							</Button>
							{currentFile && (
								<Typography variant="body2" sx={{ mt: 1 }}>
									{currentFile.name}
								</Typography>
							)}
						</Grid>
					</Grid>
				);
			}

			// SELECT / TEXT FIELD
			return (
				<Grid item xs={12} key={fieldKey} sx={{ width: "100%", mb: 2 }}>
					<Grid container spacing={1} alignItems="center">
						<Grid item xs={12} sm={4} md={3}>
							<div className="pf-label-text">{field.label}</div>
						</Grid>
						<Grid item xs={12} sm={8} md={9}>
							{field.options ? (
								<TextField
									select
									value={getFieldValue(fieldKey) || ""}
									variant="outlined"
									fullWidth
									sx={{ maxWidth: 340, height: 60 }}
									onChange={(e) => handleChange(fieldKey, e.target.value)}
									InputProps={{ style: { height: 60, padding: "14px 16px" } }}
								>
									{field.options?.map((option) => (
										<MenuItem key={option} value={option}>
											{option}
										</MenuItem>
									))}
								</TextField>
							) : (
								<TextField
									size="small"
									type={field.type === "number" ? "number" : "text"}
									value={getFieldValue(fieldKey)}
									variant="outlined"
									sx={responsiveInputStyle}
									onChange={(e) => handleChange(fieldKey, e.target.value)}
									onWheel={(e) => e.target instanceof HTMLElement && e.target.blur()}
									InputProps={{ readOnly: isReadOnly, style: { height: 60, padding: "14px 16px" } }}
									required={field.required}
								/>
							)}
						</Grid>
					</Grid>
				</Grid>
			);
		},
		[formData, validation, file, Document]
	);

	const handleNext = async () => {
		setValidationCode(Number(createValidationCode()));

		const isValid = await handleValidation();
		if (!isValid) return;

		const isFormValid = handleFormValidation();
		if (!isFormValid) return;
		// Increment step safely (max 6)
		setStep((prev) => Math.min(prev + 1, 7));
	};
	const handleBack = () => setStep((prev) => Math.max(prev - 1, 1));
	const extractNumberFromFileName = (fileName: string): string | null => {
		const match = fileName.match(/\[(\d{6})\]/);
		return match ? match[1] : null;
	};
	const handleConvert = async (selectedFile?: File) => {
		// const actualFile = selectedFile;
		if (!selectedFile) {
			alert("Please select a file first!");
			return;
		}
		const fileCode = extractNumberFromFileName(selectedFile.name);
		if (updatedPlan?.excel_validation_code) {
			if (updatedPlan?.excel_validation_code !== Number(fileCode)) {
				alert("You are not uploading the current excel file");
				return;
			}
		}

		setLoading(true);
		setJsonOutput(null);

		try {
			// Always create a NEW FileReader for each file read
			const readFile = (file: File) => {
				return new Promise<ArrayBuffer>((resolve, reject) => {
					const reader = new FileReader();
					reader.onload = () => resolve(reader.result as ArrayBuffer);
					reader.onerror = reject;
					reader.readAsArrayBuffer(file);
				});
			};

			// 🔥 Read the file NOW — guaranteed newest file
			const arrayBuffer = await readFile(selectedFile);

			const workbook = XLSX.read(new Uint8Array(arrayBuffer), { type: "array" });

			// Convert sheets to CSV
			let csvText = "";
			workbook.SheetNames.forEach((sheetName, index) => {
				const worksheet = workbook.Sheets[sheetName];
				const sheetCsv = XLSX.utils.sheet_to_csv(worksheet);
				csvText += `\n\n SHEET ${index + 1}: ${sheetName}\n${sheetCsv}`;
			});

			if (!csvText.trim()) throw new Error("No data extracted from Excel sheets.");

			// Build prompt
			let standardPrompt: string | undefined;
			let prompt: string | undefined;

			if (createdPlan) {
				standardPrompt = getPrompt(createdPlan, true);
				prompt = standardPrompt;

				if (createdPlan.is_this_plan_has_riders && createdPlan.rider) {
					const riderPrompt = getPrompt(createdPlan.rider, false);
					prompt += `\n${riderPrompt}\n(Take rider_premium from Sheet 1 if applicable)`;
				}
			}

			if (!prompt) throw new Error("Prompt generation failed.");

			const finalPrompt = `You are an expert MERN stack developer and data transformation agent.
				Your task is to read the provided CSV (converted from Excel) and output a single valid JSON object.
				This JSON will be stored in a database and later used for premium calculation, so it is **very sensitive** and must be accurate.
						Rules:
								1.example json
							${prompt}
							2.do not miss any value each value should be added in json and do not miss any benefit amount
							3. Do not use the literal string "property" as a JSON key.
							4. Do not add any extra nesting level or key between coverage_volume and pay_frequency.
							5. Do not add any extra key or numeric index between coverage_volume and pay_frequency.
								The pay_frequency keys (e.g., WEEKLY, MONTHLY) must directly contain numeric values (default 0).
							6. You are **fully responsible** for placing the correct numeric values from the CSV at the correct position in the JSON hierarchy.
								7. Output must be **only valid JSON** with no extra commentary. do not add carrier_name as key
								CSV Data:${csvText}`;

			// Call Gemini
			// const model = genAI.getGenerativeModel({ model: "gemini-2.0-flash" });
			// const result = await model.generateContent(finalPrompt);
			const data = await getJsonFromBackend("", finalPrompt);
			console.log("genime", data.result);
			// let outputText = data.result.text().trim();
			// outputText = outputText.replace(/```json|```/g, "").trim();
			let outputText = data.result;
			// outputText = outputText.replace(/```json|```/g, "").trim();

			// const jsonData = JSON.parse(outputText);
			setJsonOutput(outputText);
			// setIsFileChanged(false);
			// console.log("this is the current file", selectedFile);
			setLoading(false);
			alert("excel is process successfully");
		} catch (err: any) {
			console.error("Conversion failed:", err);
			alert(err.message);
		} finally {
			// setLoading(false);
		}
	};
	const coverageSort = (coverageArray: string[]): string[] => {
		if (!Array.isArray(coverageArray)) return [];

		const order = ["Employee Only", "Employee & Spouse", "Employee & Children", "Employee & Family"];

		return [...coverageArray].sort((a, b) => {
			const indexA = order.indexOf(a);
			const indexB = order.indexOf(b);

			// if not found in the order list, push it to the end alphabetically
			if (indexA === -1 && indexB === -1) return a.localeCompare(b);
			if (indexA === -1) return 1;
			if (indexB === -1) return -1;

			return indexA - indexB;
		});
	};
	const generateBenefitOptions = (min: any, max: any, step: any) => {
		const minNum = Number(min);
		const maxNum = Number(max);
		const stepNum = Number(step);

		if (isNaN(minNum) || isNaN(maxNum) || isNaN(stepNum) || stepNum <= 0 || maxNum < minNum) {
			return [];
		}

		const options = [];
		for (let i = minNum; i <= maxNum; i += stepNum) {
			options.push(i);
		}
		return options;
	};

	const generateSpecificAgeListOptions = (min: number, max: number) => {
		const options = [];
		for (let i = Number(min); i <= Number(max); i++) options.push(i);
		return options;
	};
	useEffect(() => {
		if (createdPlan.document && !Document) {
			setDocument(createdPlan.document);
		}
	}, [createdPlan.document, Document]);
	// console.log("this is the form data", formData);

	const handleSubmit = async () => {
		try {
			const normalizedPayFrequency = (formData.pay_frequency || []).map((pf: string) => pf.toUpperCase());
			const normalizedPayFrequencyRider = (formData["rider.pay_frequency"] || []).map((pf: string) =>
				pf.toUpperCase()
			);
			//console.log("formData.pay_frequency", formData.pay_frequency);

			let benefitOptions = generateBenefitOptions(
				Number(formData["benefit_amount.min_benefit"]),
				Number(formData["benefit_amount.max_benefit"]),
				Number(formData["benefit_amount.each_benefit_multiply_by"])
			);

			const specificAgeList = generateSpecificAgeListOptions(
				Number(formData["age_criteria.min_age"]),
				Number(formData["age_criteria.max_age"])
			);
			const riderspecificAgeList = generateSpecificAgeListOptions(
				formData["rider.age_criteria.min_age"],
				formData["rider.age_criteria.max_age"]
			);
			const riderBenefitOptions = generateBenefitOptions(
				formData["rider.benefit_amount.min_benefit"],
				formData["rider.benefit_amount.max_benefit"],
				formData["rider.benefit_amount.each_benefit_multiply_by"]
			);

			const payload = {
				group_number: createdPlan.group_number,
				plan_name: formData.plan_name,
				plan_code: formData.plan_code,
				carrier_name: formData.carrier_name,
				plan_year: formData.plan_year,
				status: formData.status, // string
				employee_class: formData.employee_class, // string
				plan_order: Number(formData.plan_order),
				start_date: formData.start_date,
				end_date: formData.end_date || null,
				auto_approve: formData.auto_approve || false,
				beneficiaries_required: formData.Beneficiaries || false,

				// is_premium_depends_on_smoke: formData.is_premium_depends_on_smoke || false,
				document: null,
				coverage_for: {
					options: coverageSort(formData.coverage_for || []),
					is_present: true,
					is_visible_in_form: true
				},

				coverage_volume: {
					// type: "select",
					options: formData.coverage_volume || [],
					is_present: formData.coverage_volume_present || false,
					is_visible_in_form: true
				},
				pay_frequency: {
					options: normalizedPayFrequency || [],
					is_present: true,
					is_visible_in_form: true
				},
				premium_amount: jsonOutput || null,
				benefit_amount: {
					is_present: formData.is_benefit || false,
					is_visible_in_form: false,

					min_benefit:
						formData.is_benefit && formData["benefit_amount.enable_specific_benefit"]
							? Number(formData["benefit_amount.min_benefit"]) || 0
							: 0,

					max_benefit:
						formData.is_benefit && formData["benefit_amount.enable_specific_benefit"]
							? Number(formData["benefit_amount.max_benefit"]) || 0
							: 0,

					each_benefit_multiply_by:
						formData.is_benefit && formData["benefit_amount.enable_specific_benefit"]
							? Number(formData["benefit_amount.each_benefit_multiply_by"]) || 0
							: 0,

					options: !formData.is_benefit
						? []
						: formData["benefit_amount.enable_specific_benefit"]
						? (benefitOptions || []).map(Number)
						: formData["benefit_amount.use_predefine_benefit"]
						? (formData["benefit_amount.benefit_band_ranges"] || []).map((x: any) => Number(x))
						: []
				},

				// is_this_plan_has_age_criteria: formData.age_criteria?.is_present || false,
				age_criteria: {
					is_present: formData["is_this_plan_has_age_criteria"] || false,
					is_visible_in_form: false,

					use_specific_ages:
						formData["is_this_plan_has_age_criteria"] && formData["age_criteria.enable_specific_ages"]
							? true
							: false,

					min_age:
						formData["is_this_plan_has_age_criteria"] && formData["age_criteria.enable_specific_ages"]
							? Number(formData["age_criteria.min_age"])
							: 0,

					max_age:
						formData["is_this_plan_has_age_criteria"] && formData["age_criteria.enable_specific_ages"]
							? Number(formData["age_criteria.max_age"])
							: 0,

					age_step: 1,

					specific_age_list:
						formData["is_this_plan_has_age_criteria"] &&
						formData["age_criteria.enable_specific_ages"] &&
						Array.isArray(specificAgeList)
							? specificAgeList
							: [],

					use_age_bands:
						formData["is_this_plan_has_age_criteria"] && formData["age_criteria.use_age_bands"]
							? true
							: false,

					age_band_ranges:
						formData["is_this_plan_has_age_criteria"] && formData["age_criteria.use_age_bands"]
							? formData["age_criteria.age_band_ranges"] || []
							: []
				},
				employee_eligibility: {
					is_present: formData.employee_eligibility?.is_present || false,
					is_visible_in_form: formData.employee_eligibility?.is_visible_in_form || false,
					employee: {
						min_age: formData["employee_eligibility.min_age"] || 18,
						max_age: formData["employee_eligibility.max_age"] || 100
					}
				},
				dependent_eligibility: {
					is_present: formData.isdependent_eligibility,
					is_visible_in_form: false,
					is_each_relationship_has_diffrent_premium:
						formData["dependent_eligibility.is_each_relationship_has_diffrent_premium"] || false,
					spouse: {
						min_age: formData["dependent_eligibility.spouse.min_age"] || 0,
						max_age: formData["dependent_eligibility.spouse.max_age"] || 26,
						can_spouse_has_max_benefit_amount_than_employee:
							formData["dependent_eligibility.spouse.can_spouse_has_max_benefit_amount_than_employee"] ||
							false
					},
					children: {
						min_age: formData["dependent_eligibility.children.min_age"] || 0,
						max_age: formData["dependent_eligibility.children.max_age"] || 26,
						can_children_has_max_benefit_amount_than_employee:
							formData[
								"dependent_eligibility.children.can_children_has_max_benefit_amount_than_employee"
							] || false,
						disabled: {
							min_age: Number(formData["dependent_eligibility.disabled.min_age"]) || 0,
							max_age: Number(formData["dependent_eligibility.disabled.max_age"]) || 26,
							children_can_exceed_employee_benefit:
								formData["dependent_eligibility.disabled.children_can_exceed_employee_benefit"] || false
						}
					},
					eligible_relationship: formData["dependent_eligibility.eligible_relationship"] || [],
					in_eligible_relationship: formData["dependent_eligibility.in_eligible_relationship"] || []
				},

				is_this_plan_has_riders: !!formData.is_this_plan_has_riders || false,
				rider: {
					is_present: formData.is_this_plan_has_riders || false,
					is_visible_in_form: true,
					name: formData["rider.name"] || "",
					is_rider_only_for_employee: formData["rider.is_rider_only_for_employee"] || false,
					is_required: formData["rider.is_required"] || false,
					is_rider_has_same_base_plan_coverage_for:
						formData["rider.is_rider_has_same_base_plan_coverage_for"] || false,

					coverage_for: {
						options: coverageSort(
							formData["rider.is_rider_only_for_employee"]
								? ["Employee Only"]
								: formData["rider.is_rider_has_same_base_plan_coverage_for"]
								? formData.coverage_for
								: formData["rider.coverage_for"] || []
						),
						is_present: formData.is_this_plan_has_riders || false,
						is_visible_in_form: true
					},

					coverage_volume: {
						options: formData["rider.coverage_volume"] || [],
						is_present: formData["rider.coverage_volume_present"] || false,
						is_visible_in_form: true
					},

					pay_frequency: {
						options: normalizedPayFrequencyRider || [],
						is_present: true,
						is_visible_in_form: true
					},

					benefit_amount: {
						is_present: formData["rider.is_benefit"] || false,
						is_visible_in_form: false,
						min_benefit: formData["rider.benefit_amount.min_benefit"] || 0,
						max_benefit: formData["rider.benefit_amount.max_benefit"] || 0,
						each_benefit_multiply_by: formData["rider.benefit_amount.each_benefit_multiply_by"] || 1,
						options: riderBenefitOptions || formData["rider.benefit_amount.benefit_band_ranges"] || []
					},
					is_premium_depends_on_smoke: formData["rider.is_premium_depends_on_smoke"] || false,

					age_criteria: {
						is_present: formData["rider.is_this_plan_has_age_criteria"] || false,
						is_visible_in_form: false,

						use_specific_ages:
							formData["rider.is_this_plan_has_age_criteria"] &&
							formData["rider.age_criteria.enable_specific_ages"]
								? true
								: false,

						min_age:
							formData["rider.is_this_plan_has_age_criteria"] &&
							formData["rider.age_criteria.enable_specific_ages"]
								? Number(formData["rider.age_criteria.min_age"])
								: 0,

						max_age:
							formData["rider.is_this_plan_has_age_criteria"] &&
							formData["rider.age_criteria.enable_specific_ages"]
								? Number(formData["rider.age_criteria.max_age"])
								: 0,

						// age_step: 1,

						specific_age_list:
							formData["rider.is_this_plan_has_age_criteria"] &&
							formData["rider.age_criteria.enable_specific_ages"] &&
							Array.isArray(riderspecificAgeList)
								? riderspecificAgeList
								: [],

						use_age_bands:
							formData["rider.is_this_plan_has_age_criteria"] &&
							formData["rider.age_criteria.use_age_bands"]
								? true
								: false,

						age_band_ranges:
							formData["rider.is_this_plan_has_age_criteria"] &&
							formData["rider.age_criteria.use_age_bands"]
								? formData["rider.age_criteria.age_band_ranges"] || []
								: []
					},

					isriderdependent_eligibility: formData["rider.is_rider_dependent_eligibility"] || false,

					dependent_eligibility: {
						is_present: formData["rider.is_rider_dependent_eligibility"],
						spouse: {
							min_age: formData["rider.dependent_eligibility.spouse.min_age"] || 0,
							max_age: formData["riderdependent_eligibility.spouse.max_age"] || 0,
							can_spouse_has_max_benefit_amount_than_employee:
								formData[
									"rider.dependent_eligibility.spouse.can_spouse_has_max_benefit_amount_than_employee"
								] || false
						},
						children: {
							min_age: formData["rider.dependent_eligibility.children.min_age"] || 0,
							max_age: formData["rider.dependent_eligibility.children.max_age"] || 0,
							can_children_has_max_benefit_amount_than_employee:
								formData[
									"rider.dependent_eligibility.children.can_children_has_max_benefit_amount_than_employee"
								] || false,
							disabled: {
								min_age: formData["rider.dependent_eligibility.children.disabled.min_age"] || 0,
								max_age: formData["rider.dependent_eligibility.children.disabled.max_age"] || 0,
								children_can_exceed_employee_benefit:
									formData[
										"rider.dependent_eligibility.children.disabled.children_can_exceed_employee_benefit"
									] || false
							}
						},
						eligible_relationship: formData["rider.dependent_eligibility.eligible_relationship"] || [],
						in_eligible_relationship: formData["rider.dependent_eligibility.in_eligible_relationship"] || []
					}
				},

				step: step,
				excel_validation_code: validationCode,
				rider_plan_dependency: formData["rider_plan_dependency"],
				standard_plan_dependency: formData["standard_plan_dependency"]
			};
			// console.log("payload", payload);

			// formDataPayload.append("plan", JSON.stringify(payload));

			setLoading(true);
			// console.log("updatedPlan", updatedPlan);
			const excelPayload = {
				carrier_name: {
					value: createdPlan?.carrier_name || "",
					type: "string",
					is_present: true,
					is_visible_in_form: true
				},
				auto_approve: payload.auto_approve,
				is_premium_depends_on_smoke: formData["is_premium_depends_on_smoke"] || false,
				coverage_for: payload.coverage_for,
				coverage_volume: payload.coverage_volume,
				pay_frequency: payload.pay_frequency,
				premium_amount: payload.premium_amount,
				benefit_amount: payload.benefit_amount,
				is_this_plan_has_age_criteria: payload.age_criteria.is_present,
				age_criteria: payload.age_criteria,
				dependent_eligibility: payload.dependent_eligibility,
				is_this_plan_has_riders: payload.is_this_plan_has_riders,
				rider: payload.rider
			};
			if (step === 5) {
				try {
					const updatedPlan = await api.plan.updateVEBPlan(createdPlan._id, payload);
					setUpdatedPlan(updatedPlan);
					if (updatedPlan) {
						setValidationCode(updatedPlan?.excel_validation_code);
					}
					//console.log("updated payload", payload);
				} catch (error) {
					console.log(error);
				}
				try {
					if (Document || createdPlan?.document) {
						const formData = new FormData();

						// backend needs this!!
						formData.append(
							"plan",
							JSON.stringify({
								_id: createdPlan._id,
								group_number: createdPlan.group_number as number,
								document: null
							})
						);

						// backend needs this!!
						formData.append("document", Document || createdPlan?.document);

						const updatedDocument = await trackPromise(api.plan.updatePlanDocument(formData));
					}
				} catch (error) {
					console.log(error);
				}
			}
			if (step === 5) {
				// console.log("hi bro its not working");
				await jsonToExcel(`${createdPlan.plan_name}_PREMIUM[${validationCode}].xlsx`, excelPayload);
			}

			if (step === 6) {
				const { document, ...payloadCopy } = payload;

				const updatedPlan = await api.plan.updateVEBPlan(createdPlan._id, payloadCopy);
				if (updatedPlan) {
					updateAllplanOrder();
				}

				alert("Plan updated successfully!");
				onClose();
				window.location.reload();
				navigate(`/employer/plan-management${createdPlan.group_number}`);
			}
		} catch (err: any) {
			console.error(err);
			alert(err.response?.data?.message || "Failed to update plan");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (targetOrder != null) {
			setFormData((prev) => ({ ...prev, plan_order: targetOrder }));
		}
	}, [targetOrder, createdPlan]);
	useEffect(() => {
		if (!activePlans?.length) return;

		const planNames: string[] = activePlans
			.map((plan) => plan.plan_name)
			.filter((name): name is string => Boolean(name));

		const riderPlanname: string[] = activePlans
			.map((plan) => plan.rider?.name)
			.filter((name): name is string => Boolean(name));

		setActivePlansName(planNames);
		setActiveRiderPlansName(riderPlanname);
		const formatted: PlanOrderItem[] = activePlans.map((plan) => ({
			plancode: plan.plan_code,
			planOrder: plan.plan_order,
			planName: plan.plan_name,
			planID: plan._id
		}));

		setPlanOrderList(formatted);
	}, [activePlans]);
	useEffect(() => {
		getallplans();
	}, [getallplans, targetOrder]);
	return (
		<Dialog
			open
			onClose={onClose}
			maxWidth={false}
			PaperProps={{
				sx: {
					width: { xs: "98%", sm: 600, md: 900, lg: 1300 }, // wider dialog
					p: { xs: 1, sm: 2 }, // more padding around edges
					borderRadius: 3,
					maxHeight: "98vh", // almost full screen height
					display: "flex",
					flexDirection: "column",
					backgroundColor: "#F7F7DF",
					boxShadow: "0px 10px 30px rgba(0,0,0,0.2)",
					overflow: "hidden"
				}
			}}
		>
			<DialogTitle sx={{ fontSize: 22, fontWeight: 600 }}>Update VEB Plan</DialogTitle>

			<DialogContent sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 1 }}>
				<LinearProgress
					variant="determinate"
					value={(step / steps.length) * 100}
					sx={{
						mb: 2,
						height: 12,
						borderRadius: 6,
						"& .MuiLinearProgress-bar": { borderRadius: 6 }
					}}
				/>

				{/* Stepper Section */}
				<Box
					sx={{
						mb: 3,
						width: "100%",
						p: { xs: 1.5, sm: 2.5 },
						bgcolor: "#f0f0f0",
						borderRadius: 3,
						boxShadow: "inset 5px 5px 10px #d9d9d9, inset -5px -5px 10px #ffffff",
						transition: "all 0.3s ease",
						position: "static"
					}}
				>
					<Stepper
						activeStep={step - 1}
						alternativeLabel
						sx={{ flexWrap: { xs: "wrap", sm: "nowrap" }, p: 0, height: "35px" }}
					>
						{steps.map((label, idx) => (
							<Step key={label}>
								<StepLabel
									StepIconComponent={GreenStepIcon}
									onClick={() => setStep(idx + 1)}
									sx={{ cursor: "pointer" }}
								>
									{label}
								</StepLabel>
							</Step>
						))}
					</Stepper>

					<LinearProgress
						variant="determinate"
						value={(step / steps.length) * 100}
						sx={{
							height: 5,
							borderRadius: 5,
							mt: 1,
							bgcolor: "#e0e0e0",
							"& .MuiLinearProgress-bar": {
								borderRadius: 5,
								backgroundColor: "green"
							}
						}}
					/>
				</Box>

				{/* Main Paper Section */}
				<Paper
					sx={{
						p: 4,
						flex: 1,
						overflow: "auto",
						minHeight: { xs: 600, sm: 800, md: 1000 }, // more height
						maxHeight: { xs: 700, sm: 900, md: 1100 },
						borderRadius: 3,
						boxShadow: "0px 8px 20px rgba(0,0,0,0.15)",
						backgroundColor: "white",
						"&::-webkit-scrollbar": { display: "none" },
						msOverflowStyle: "none",
						scrollbarWidth: "none"
					}}
				>
					{VEBConfig.filter((f) => f.step === step).map((field) => renderField(field))}
					<Modal open={showModal} onClose={handleCancel} aria-labelledby="duplicate-order-modal">
						<Box
							sx={{
								position: "absolute",
								top: "50%",
								left: "50%",
								transform: "translate(-50%, -50%)",
								width: 550,
								maxHeight: "80vh",
								overflowY: "auto",
								bgcolor: "background.paper",
								boxShadow: 24,
								borderRadius: 3,
								p: 4
							}}
						>
							{/* Header */}
							<Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
								<Typography
									id="duplicate-order-modal"
									variant="h6"
									sx={{
										fontWeight: 700,
										textTransform: "uppercase",
										letterSpacing: "0.5px"
									}}
								>
									Duplicate Plan Order
								</Typography>

								<IconButton onClick={handleCancel}>
									<IoCloseCircleOutline size={24} />
								</IconButton>
							</Box>

							{/* Info */}
							<Typography sx={{ mb: 2, fontSize: 14 }}>
								The plan order <b>{formData.plan_order}</b> is already assigned to the following
								plan(s):
							</Typography>

							{/* Table */}
							<Box sx={{ mb: 3 }}>
								<Table
									size="small"
									sx={{
										border: "1px solid #e0e0e0",
										borderRadius: 2,
										overflow: "hidden"
									}}
								>
									<TableHead>
										<TableRow
											sx={{
												bgcolor: "#f7f9fc",
												"& th": {
													fontWeight: 600,
													color: "#374151",
													fontSize: "0.85rem",
													borderBottom: "1px solid #e5e7eb"
												}
											}}
										>
											<TableCell>Plan Name</TableCell>
											<TableCell>Plan Code</TableCell>
											<TableCell align="center">Plan Order</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{planOrderList.map((plan) => (
											<TableRow
												key={plan.plancode}
												sx={{
													"&:hover": { bgcolor: "#f9fafb" },
													"& td": {
														fontSize: "0.85rem",
														color: "#111827",
														borderBottom: "1px solid #f1f5f9"
													}
												}}
											>
												<TableCell>{plan.planName}</TableCell>
												<TableCell>
													<Typography variant="body2" color="text.secondary">
														{plan.plancode}
													</Typography>
												</TableCell>
												<TableCell align="center">
													<Typography>{plan.planOrder}</Typography>
												</TableCell>
											</TableRow>
										))}
									</TableBody>
								</Table>
							</Box>

							{/* Actions */}
							<Box display="flex" justifyContent="flex-end" flexWrap="wrap" gap={2}>
								<TextField
									type="text"
									label="Position"
									value={targetOrder ?? ""}
									onChange={(e) => {
										const value = Number(e.target.value);
										setTargetOrder(value);
									}}
								/>

								<Button
									variant="contained"
									// color="green"
									sx={{ backgroundColor: "green" }}
									onClick={() => targetOrder !== null && handleMoveToPosition(targetOrder)}
								>
									Move to Specific Position
								</Button>

								<Button
									variant="outlined"
									color="inherit"
									size="medium"
									onClick={handleCancel}
									sx={{ textTransform: "none", px: 2, py: 1 }}
								>
									Cancel
								</Button>
							</Box>
						</Box>
					</Modal>
				</Paper>

				{step === 2 && jsonOutput && (
					<pre
						style={{
							maxHeight: 250,
							overflow: "auto",
							background: "#f5f5f5",
							padding: 10
						}}
					>
						{JSON.stringify(jsonOutput, null, 2)}
					</pre>
				)}
			</DialogContent>

			<DialogActions sx={{ justifyContent: "space-between", mt: 3 }}>
				<Button sx={{ backgroundColor: "red", color: "white" }} onClick={onClose}>
					Cancel
				</Button>

				<Box sx={{ display: "flex", gap: 1 }}>
					{step > 1 && <Button onClick={handleBack}>Back</Button>}

					<Button
						variant="contained"
						sx={{ backgroundColor: "green" }}
						onClick={async () => {
							// ---------- STEP 6 LOGIC ----------
							if (step === 6) {
								if (!jsonOutput) {
									await handleConvert();
								}

								if (jsonOutput) {
									await handleSubmit();
								}

								return handleNext();
							}

							if (step === 5) {
								await handleSubmit();

								return handleNext();
							}

							handleNext();
						}}
						disabled={loading}
					>
						{step === 5 ? "Generate Excel" : step === 6 ? "Submit & Finish" : "Next"}
					</Button>
				</Box>
			</DialogActions>
		</Dialog>
	);
};

export default UpdateVEBPlan;
